export enum DataSelectionUIType {
  CODE = 'code',
  TIMERESTRICTION = 'timeRestriction',
}
